import React from 'react';
import { StyleSheet } from 'react-native';

import { theme } from '@garnish/constants';
import { Alert, Icon } from '@garnish/core';

// ─────────────────────────────────────────────────────────────────────────────

export const ShareLineItemLocationAlert = (props: Props) => {
  const { message, palette = 'info' } = props;

  return (
    <Alert.Container palette={palette} size="lg" style={styles.container}>
      <Icon name="IconInfo" color={theme.colors.DARK_KALE} width={16} height={16} />
      <Alert.Text sizeMatch={['14']}>{message}</Alert.Text>
    </Alert.Container>
  );
};

// ─── Styles ─────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    gap: theme.spacing['2'],
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  message: string;
  palette?: 'caution' | 'info';
};
